import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { Group, User } from '@era/security-sdk';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserSearchBarComponent } from '../../users/user-search-bar/user-search-bar.component';

@Component({
  selector: 'era-security-add-member-modal-ui',
  templateUrl: './add-member-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [UserSearchBarComponent],
})
export class AddMemberModalComponent {
  private readonly modal = inject(NgbActiveModal);

  public items: Group[] | User[];
  public selectedItem: Group | User | null = null;

  itemSelected(item: Group | User): void {
    this.selectedItem = item ?? null;
  }

  closeModal(): void {
    this.modal.dismiss();
  }

  addMembers(): void {
    this.modal.close(this.selectedItem);
  }
}
